import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import BillingDetailsActions from '../actions/BillingDetailsActions';


const BillingDetailsSource = {

    getBillingDetails() {
        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.myBillingDetails).fetch();
            },

            success: BillingDetailsActions.getBillingDetailsSuccess,
            error: BillingDetailsActions.getBillingDetailsFailed
        }
    }
};

class BillingDetailsStore {
    constructor() {
        this.billingDetails = {};
        this.billingDetailsReceived = false;
        this.billingDetailsSaved = false;
        this.exportAsync(BillingDetailsSource);
        this.bindActions(BillingDetailsActions);
    }

    onGetBillingDetailsSuccess(billingDetails) {
        this.setState({billingDetails, billingDetailsReceived: true});
    }

    onClearBillingDetailsData() {
        this.setState({billingDetails: {}, billingDetailsReceived: false});
    }
}

export default createStore(BillingDetailsStore, 'BillingDetailsStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/BillingDetailsStore.js
 **/